import React, { useState } from 'react';
import { Edit, Copy, Trash } from 'lucide-react';
import styles from '../../styles/automation-styles';

// ActionMenu Component
const ActionMenu = ({ isOpen, position, onClose, selectedAutomation, deleteAsync, cloneItemAsync, getItemForUpdateAsync }) => {
    const [hoverIndex, setHoverIndex] = useState(null);

    if (!isOpen) return null;

  const handleDelete = () => {
    deleteAsync(selectedAutomation.id);
    onClose();
  }

  const handleClone = () => {
    cloneItemAsync(selectedAutomation.id);
    onClose();
  }

  const editItem = () => {
    getItemForUpdateAsync(selectedAutomation.id);
    onClose();
  }
    
    return (
      <div 
        style={{
          ...styles.actionMenu,
          top: position.y,
          left: position.x
        }}
      >
        <ul style={styles.menuList}>
          <li 
            style={{
              ...styles.menuItem,
              ...(hoverIndex === 0 ? styles.menuItemHover : {})
            }}
            onClick={editItem}
            onMouseEnter={() => setHoverIndex(0)}
            onMouseLeave={() => setHoverIndex(null)}
          >
            <Edit size={16} />
            <span style={styles.menuText}>Editar</span>
          </li>
          <li 
            style={{
              ...styles.menuItem,
              ...(hoverIndex === 1 ? styles.menuItemHover : {})
            }}
            onClick={handleClone}
            onMouseEnter={() => setHoverIndex(1)}
            onMouseLeave={() => setHoverIndex(null)}
          >
            <Copy size={16} />
            <span style={styles.menuText}>Clonar</span>
          </li>
          <li 
            style={{
              ...styles.menuItem,
              ...styles.deleteMenuItem,
              ...(hoverIndex === 2 ? styles.menuItemHover : {})
            }}
            onClick={handleDelete}
            onMouseEnter={() => setHoverIndex(2)}
            onMouseLeave={() => setHoverIndex(null)}
          >
            <Trash size={16} />
            <span style={styles.menuText}>Eliminar</span>
          </li>
        </ul>
      </div>
    );
  };

export default ActionMenu;